import { clearLocalStorageByPrefix } from '/@/utils/localStorage';

export const LOCAL_STORAGE_KEY_PREFIX = 'AgeCalculator-panel-';
export const LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEY_PREFIX + '{panelId}-measurement-{id}-v3';
export const LOCAL_STORAGE_KEY_VERIFY_ERROR = LOCAL_STORAGE_KEY_PREFIX + '{panelId}-measurement-{id}-verifyError';

export function clearLocalStorage(panelId) {
    if (panelId === "all") {
        clearLocalStorageByPrefix(LOCAL_STORAGE_KEY_PREFIX);
        return;
    }
    if (typeof panelId !== "number") {
        throw new Error("panelId must be a number or 'all'");
    }
    clearLocalStorageByPrefix(LOCAL_STORAGE_KEY_PREFIX + `${panelId}`);
}
